const conutryKeyList = ['region_country'];

const getFilterValue = (value: any, filter: any) => {
  const { options, default: defaultValue, key, type } = filter || {};
  const filterKey = key || type;
  const valueList: any = [];
  options?.forEach((item: any) => {
    if (conutryKeyList?.includes(filterKey)) {
      item?.children?.forEach((child: { value: any; }) => {
        valueList.push(child?.value);
      });
    } else {
      valueList.push(item?.value);
    }
  });

  // 处理国家value(对象格式)
  if (conutryKeyList?.includes(filterKey)) {
    // 过滤掉没有在options中的值
    const filterValue = value?.market?.filter((v: any) => valueList?.includes(v));
    const newValue =
      filterValue?.length > 0
        ? {
            ...value,
            market: filterValue,
          }
        : defaultValue;
    return newValue;
  }
  // 其他类型直接赋值
  // 过滤掉没有在options中的值
  const newValue = value?.filter((v: any) => valueList?.includes(v));
  // 过滤后没值，使用默认值兜底
  return newValue?.length > 0 ? newValue : defaultValue;
};

export const getSaveValue = (value: any, filterValue: any, fields: any[]) => {
  const saveValue: any = {};
  fields?.forEach((item: any) => {
    const { key, type, saveKey } = item;
    const filterKey = key || type;
    const saveKeyValue = saveKey || key || type;
    // 没有key值，直接返回
    if (!filterKey) return;
    // 其他类型直接赋值
    saveValue[filterKey] = filterValue?.[saveKeyValue] || value?.[filterKey];
    // saveValue[filterKey] = getFilterValue(filterValue?.[filterKey], item);
  });
  return saveValue;
};
export const setSaveValue = (filterValueObj: any, fields: any[]) => {
  const filterValue = filterValueObj?.filter_value || {};
  const saveValue: any = {};
  fields?.forEach((item: any) => {
    const { key, type, saveKey } = item;
    const saveKeyValue = saveKey || key || type;
    const filterKey = key || type;
    // 没有key值，直接返回
    if (!filterKey) return;
    // 其他类型直接赋值
    saveValue[saveKeyValue] = filterValue?.[filterKey];
    // saveValue[filterKey] = getFilterValue(filterValue?.[filterKey], item);
  });

  return {
    ...filterValueObj,
    filter_value: saveValue,
  };
};
export const setStorageValue = (filterValue: any, fields: any[]) => {
  const saveValue: any = {};
  fields?.forEach((item: any) => {
    const { key, type, saveKey } = item;
    const saveKeyValue = saveKey || key || type;
    const filterKey = key || type;
    // 没有key值，直接返回
    if (!filterKey) return;
    // 其他类型直接赋值
    saveValue[saveKeyValue] = filterValue?.[filterKey];
    // saveValue[filterKey] = getFilterValue(filterValue?.[filterKey], item);
  });
  return {
    ...saveValue,
  };
};
